import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverviewAI = _resolveComponent("OverviewAI")!
  const _component_OverviewWrapper = _resolveComponent("OverviewWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isOverviewAI)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_OverviewAI, { studyId: _ctx.studyId }, null, 8 /* PROPS */, ["studyId"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", null, [
      _createVNode(_component_OverviewWrapper)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}